module.exports = __webpack_public_path__ + "static/media/history-min.c2425d59.jpg";